export default "__VITE_ASSET__B$l3rQ0L__"